if (!customElements.get('mg-product-finder')) {
  customElements.define('mg-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-finder-config]').textContent);
      this.form = this.querySelector('form');
      this.powerStep = this.querySelector('[data-power-step]');
      this.results = this.querySelector('[data-finder-results]');
      this.cards = [...this.querySelectorAll('[data-finder-product]')];
      this.status = this.querySelector('[data-finder-status]');
      this.handleChange = event => {
        if (event.target.name === 'finder_place') {
          this.form.querySelectorAll('[name="finder_power"]').forEach(input => { input.checked = false; });
        }
        this.update();
      };
      this.handleReset = () => {
        this.form.reset();
        this.update();
        this.form.querySelector('[name="finder_place"]').focus();
      };
      this.form.addEventListener('change', this.handleChange);
      this.querySelector('[data-finder-reset]').addEventListener('click', this.handleReset);
      this.hidden = false;
      this.update();
    }
    update() {
      const place = this.form.querySelector('[name="finder_place"]:checked')?.value;
      const power = this.form.querySelector('[name="finder_power"]:checked')?.value;
      const needsPower = place && place !== 'pipe';
      this.powerStep.hidden = !needsPower;
      this.powerStep.disabled = !needsPower;
      this.form.querySelectorAll('[data-power-places]').forEach(label => {
        const allowed = Boolean(place && label.dataset.powerPlaces.split(' ').includes(place));
        label.hidden = !allowed;
        label.querySelector('input').disabled = !allowed;
      });
      const route = place === 'pipe' ? 'pipe' : `${place}.${power || ''}`;
      const suggestions = this.config.routes[route] || [];
      this.results.hidden = suggestions.length === 0;
      this.cards.forEach(card => { card.hidden = true; });
      suggestions.forEach((suggestion, index) => {
        const card = this.cards.find(item => item.dataset.finderProduct === suggestion.sku);
        if (!card) return;
        card.querySelector('[data-match-reason]').textContent = suggestion.reason;
        card.style.order = String(index);
        card.hidden = false;
      });
      this.querySelector('[data-finder-compare]').setAttribute('href', `#keuze-${({car:'auto',inside:'binnen',outside:'buiten',pipe:'regenpijp'})[place] || 'auto'}`);
      this.querySelector('[data-finder-note]').textContent = this.config.notes[place] || '';
      this.status.textContent = suggestions.length ? this.config.messages[suggestions.length === 1 ? 'one' : 'two'] : '';
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.handleChange);
      this.querySelector('[data-finder-reset]')?.removeEventListener('click', this.handleReset);
      this.initialized = false;
    }
  });
}
